<div class="page">
  <!-- Header Section -->
  <div class="cardHeader mb-3">
    <!-- Heading -->
    <h5 class="mb-2">Method of Payment on File</h5>

    <!-- Select + Buttons Row -->
    <div class="flex flex-column md:flex-row md:align-items-center md:justify-between gap-3">
      <!-- Payment Toggle -->
      <p-selectButton [options]="paymentOptions"
                      optionLabel="label"
                      optionValue="value"
                      [(ngModel)]="valSelect1"
                      (ngModelChange)="onOptionSelected()"
                      class="w-full md:w-auto">
      </p-selectButton>

      <!-- Download Buttons aligned right of toggle -->
      <div class="flex flex-wrap gap-2 justify-content-end">
        <button pButton
                type="button"
                icon="pi pi-download"
                label="Current"
                class="p-button-sm p-button-text p-button-secondary"
                (click)="downloadCurrentRebates()">
        </button>

        <button pButton
                type="button"
                icon="pi pi-download"
                label="Historical"
                class="p-button-sm p-button-text p-button-secondary"
                (click)="downloadHistoricalRebates()">
        </button>

        <button pButton
                type="button"
                icon="pi pi-file-excel"
                label="All Excel"
                class="p-button-sm p-button-text p-button-secondary"
                (click)="downloadRebatesExcel()">
        </button>
      </div>
    </div>
  </div>

  <!-- Card Deck -->
  <div class="card-deck grid gap-4">
    <!-- Quarterly Rebates -->
    <div class="card col-12 md:col-6">
      <div class="flex align-items-center justify-content-between mb-3">
        <div class="text-900 text-xl font-semibold">
          <i class="pi pi-chart-line text-primary mr-2"></i> Quarterly Rebates
        </div>
      </div>

      <div class="CheckAmount mt-3">
        Payment Total: {{ totalCurrentQuarterly | currency }}
      </div>

      <br /><br />

      <p-table [value]="currentQuarterly"
               responsiveLayout="scroll"
               [globalFilterFields]="['name','amount']">

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name" class="white-space-nowrap">
              Vendor <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="amount" class="white-space-nowrap">
              Amount <p-sortIcon field="amount"></p-sortIcon>
            </th>
            <th class="white-space-nowrap">Issue Date</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-payment>
          <tr>
            <td>{{ payment.name }}</td>
            <td>{{ payment.amount | currency }}</td>
            <td>{{ payment.date }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Historical Rebates -->
    <div class="card col-12 md:col-6">
      <div class="flex align-items-center justify-content-between mb-3">
        <div class="text-900 text-xl font-semibold">
          <i class="pi pi-folder-open text-primary mr-2"></i> Historical Rebates
        </div>
      </div>

      <p-treeTable [value]="historicalQuarterly"
                   [columns]="cols"
                   [resizableColumns]="true">

        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" [style.width]="col.width" />
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body"
                     let-rowNode
                     let-rowData="rowData"
                     let-columns="columns">
          <tr>
            <td *ngFor="let col of columns; let i = index">
              <p-treeTableToggler [rowNode]="rowNode"
                                  *ngIf="i === 0">
              </p-treeTableToggler>

              <div *ngIf="col.field === 'amount'; then currencyContent else textContent"></div>

              <ng-template #currencyContent>
                {{ rowData[col.field] | currency }}
              </ng-template>

              <ng-template #textContent>
                {{ rowData[col.field] }}
              </ng-template>
            </td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
  </div>
</div>
